import { reactive, Ref } from "vue";
import { getBaseEndpoint } from "./../config/config.ts";
import { Language } from "./camping-api-v1.service.ts";

const BASE_API = getBaseEndpoint(process.env.NODE_ENV)


export interface Texts {
  [key: number]: string;
}

export interface TextResults {
  status: string;
  data: Texts;
}

export const translate = async (options: {
  id: number[];
  language?: string;
}) => {
  let ids = "?";
  options.id.forEach((id) => {
    ids += `textIds=${id}&`;
  });
  const result = await fetch(`${BASE_API}/api/translation/GetTranslations${ids}`, {
    headers: {
      Accept: "application.json",
      "Content-Type": "application/json"
    },
    method: "GET",
  })
    .then((res) => res.json())
    .then((res) => {
      return res
    })
    .catch((err) => console.error('❌ ', err));

  return await result;
};





const translationMap = reactive( new Map<number, string>() );
let keysToTranslate: number[] = [];
let debounceTimeout: NodeJS.Timeout | null = null;
/**
 * Returns a reactive reference to the text (empty string until loaded).
 * Subsequent calls on the same page will get the text directly from a Map.
 * @textId The TextId to get the translation for.
 */
export const getText = (textId: number) => {
  if (translationMap.has(textId)) {
    return translationMap.get(textId)
  }

  translationMap.set(textId, "")

  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
  keysToTranslate.push(textId)
  debounceTimeout = setTimeout(() => {
    translateKeysInChunks(keysToTranslate)
    keysToTranslate = [];
  }, 10);
  return translationMap.get(textId)
}

export const hasText = (textId: number) => {
  return translationMap.has(textId);
}

let waitForDataResolve: Function;
let waitForData = new Promise((resolve) => {
  waitForDataResolve = resolve
})
/**
 * Returns a reactive reference to the text (empty string until loaded).
 * Subsequent calls on the same page will get the text directly from a Map.
 * Use with await to wait for the text to be loaded.
 * @textId The TextId to get the translation for.
 */
export const getTextAsync = async (textId: number) => {
  if (translationMap.has(textId)) {
    return translationMap.get(textId)
  }

  waitForData = new Promise((resolve) => {
    waitForDataResolve = resolve
  })
  if (debounceTimeout) {
    clearTimeout(debounceTimeout);
  }
  keysToTranslate.push(textId)
  debounceTimeout = setTimeout(async () => {
    await translateKeysInChunks(keysToTranslate)
    waitForDataResolve()
    keysToTranslate = [];
  }, 10);
  await waitForData
  return translationMap.get(textId)
}

const translateKeysInChunks = async (keysToTranslate: number[]) => {
  const chunkSize = 110
  const idChunks = idChunkArray(keysToTranslate, chunkSize)

  let allPromises = [];

  for (const chunk of idChunks) {
    allPromises.push(translateKeys(chunk))
  }

  return Promise.all(allPromises);
}

const idChunkArray = (array: number[], chunkSize: number) => {
  const results = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    results.push(array.slice(i, i + chunkSize));
  }
  return results;
};

const translateKeys = async (ids: number[]) => {
  let params = "?";
  ids.forEach((id) => {
    params += `textIds=${id}&`;
  });
  const result = await fetch(`${BASE_API}/api/translation/GetTranslations${params}`, {
    headers: {
      Accept: "application.json",
      "Content-Type": "application/json"
    },
    method: "GET",
  })
  if (result.ok) {
    const translations = await result.json();
    for (let [key, value] of Object.entries(translations)) {
      translationMap.set(Number(key), value)
    }
  } else {
    console.error('❌ ', result)
  }

  return await result;
};


export function getSiteLanguage(): Language {
  let language = document.documentElement.lang || 'en-UK';
  language = language.toLowerCase();
  switch (language) {
    case 'en-gb':
      return "English";
    case 'en-us':
      return "EnglishAmerican";
    case 'da-dk':
      return "Danish";
    case 'de-de':
      return "German";
    case 'es-es':
      return "Spanish";
    case 'fr-fr':
      return "French";
    case 'it-it':
      return "Italian";
    case 'nl-nl':
      return "Dutch";
    case 'no-no':
      return "Norwegian";
    case 'pl-pl':
      return "Polish";
    case 'sv-se':
      return "Swedish";
    case 'cs-cz':
      return "Czech";
    default:
      return "English"; // Default to English if no match found
  }
}
